import debounce from 'lodash/debounce';
import { SENDBEACON_MECHANISM } from 'saddlebag-grappler';
import { MiniEventsTracking } from 'saddlebag-user-tracking-events';

import type { MBDEvent } from '@web-platform/shared-universal-types-tracking/src/MBDTypes';

export const miniEventsTracking = new MiniEventsTracking('public', 'banana', {
  enhance: false,
  mechanism: SENDBEACON_MECHANISM,
});

export const sendEvent = (event: MBDEvent, messageGuid?: string) => {
  const fullSchemaName =
    'element_impression_guid' in event
      ? 'user_behaviour_data_domain.ElementInteraction'
      : 'user_behaviour_data_domain.ElementImpression';
  const eventConfig = messageGuid ? { messageGuid } : undefined;

  return miniEventsTracking.track('mbd-web', fullSchemaName, event, eventConfig);
};

const queue: Array<() => void> = [];

const dequeueWithDebounce = debounce(() => {
  const fn = queue.shift();
  if (fn) fn();
  if (queue.length) dequeueWithDebounce();
}, 50);

export const sendEventWithDebounce = (event: MBDEvent, messageGuid?: string) => {
  queue.push(() => {
    sendEvent(event, messageGuid);
  });
  dequeueWithDebounce();
};
